export default __webpack_public_path__ + "static/media/bravo1.dcfefdb4.png";